var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visible"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visible--Streamline-Flex.svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2609540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 21",
    d: "M20.6552 12.0007C20.6552 13.4743 16.7282 18.6673 11.8833 18.6673C7.03835 18.6673 3.11133 13.4743 3.11133 12.0007C3.11133 10.527 7.03835 5.33398 11.8833 5.33398C16.7282 5.33398 20.6552 10.527 20.6552 12.0007Z",
    stroke: "#024776",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8832 14.8074C13.6797 14.8074 14.6902 13.7969 14.6902 12.0004C14.6902 10.2039 13.6797 9.19336 11.8832 9.19336C10.0867 9.19336 9.07617 10.2039 9.07617 12.0004C9.07617 13.7969 10.0867 14.8074 11.8832 14.8074Z",
    stroke: "#024776",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f4dd8215e569181ef2fcc69816d79ea9.svg";
export { ForwardRef as ReactComponent };